<template>
    <div :class="['auth_layout', {'center': centerVertically}]">
        <div class="auth_layout--inner" :style="'max-width: ' + width + 'px'">
            <div class="auth_logo">
                <img class="auth_logo--img" src="/images/forefront-logo.png" alt="Forefront">
            </div>

            <section-box class="auth_layout--box">
                <div v-if="message" class="content">
                    <h3 class="title is-4 has-text-centered" v-html="message"></h3>
                    <p v-if="subMessage" class="subtitle is-5 has-text-centered" v-html="subMessage"></p>
                </div>

                <slot></slot>
            </section-box>

            <div class="auth_links">
                <p v-if="showRegisterLink" class="auth_links--item">Don't you have an account? <a :href="registerLink">Sign up now</a></p>
                <p v-if="routeName === 'register'" class="auth_links--item">Already have an account? <router-link :to="{ name: 'login' }">Login</router-link></p>
                <p v-if="routeName === 'password-request'" class="auth_links--item">Remember Your Password? <router-link :to="{ name: 'login' }">Login</router-link></p>
                <p v-if="routeName === 'password-reset'" class="auth_links--item">Remember Your Password? <router-link :to="{ name: 'login' }">Login</router-link></p>
            </div>
        </div>

        <div id="page-modals">
            <slot name="modals"></slot>
        </div>
    </div>
</template>

<script>

export default {
  name: "LayoutAuth",
  props: {
    width: {
      type: Number,
      default: 440
    },
    message: {
      type: String,
    },
    subMessage: {
      type: String
    },
    centerVertically: {
      type: Boolean,
      default: true
    },
    showRegisterLink: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      registerLink: process.env.MIX_SIGNUP_URL || 'https://forefrontcrm.com/pricing'
    }
  },
  mounted() {
    // This is here so that html, body, and #app have height set via css
    const root = document.documentElement
    root.classList.add('layout_page')
  },
  computed: {
    routeName() {
      return this.$route.name;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.title {
  margin-bottom: 2rem;
  color: $text-muted;
}

.subtitle {
  color: $text-muted;
}
</style>
